












import Vue from 'vue';
import { BFormInput } from 'bootstrap-vue';
import { ZenFormGroup } from 'zenComponents';

export default Vue.extend({
  name: 'RiskCardNumber',
  components: {
    BFormInput,
    ZenFormGroup,
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
});
